(() => {
  const variants = new Map([[61156111647054,1],[61156111679822,2],[61156111712590,3],[61156111745358,4],[61156111778126,5],[61156111810894,6],[61156111843662,10],[61156111876430,20]]);
  const sorts = ['Småfranska','Solrosfralla','Ostfralla','Linfröfralla'];
  const slots = new Set(['07–08','08–09','09–10']);
  function check(cart, now = new Date()) {
    const today = new Date(new Intl.DateTimeFormat('sv-SE',{timeZone:'Europe/Stockholm',year:'numeric',month:'2-digit',day:'2-digit'}).format(now)+'T00:00:00Z');
    const weekday = today.getUTCDay();
    const saturday = new Date(today); saturday.setUTCDate(today.getUTCDate()+6-weekday);
    const date = saturday.toISOString().slice(0,10);
    if(weekday>4 || date<'2026-10-17' || date>'2026-11-21') return 'Beställningarna är stängda just nu. Nästa beställningsperiod öppnar på söndag.';
    if(!cart.items?.length) return 'Lägg till en frallpåse först.';
    let total=0, time;
    for(const line of cart.items) {
      const size=variants.get(Number(line.variant_id)), p=line.properties||{};
      if(!size || !Number.isInteger(line.quantity) || line.quantity<1) return 'Gå tillbaka till frallpåsen och välj antal och sorter igen.';
      if(p.Leveransdatum!==date) return 'Varukorgen innehåller en påse från en tidigare vecka. Ta bort den och välj en ny påse för lördag '+saturday.getUTCDate()+'/'+(saturday.getUTCMonth()+1)+'.';
      if(!slots.has(p.Leveranstid)) return 'Välj leveranstid på frallpåsen innan du går till kassan.';
      if(time && time!==p.Leveranstid) return 'Välj samma leveranstid för alla påsar i beställningen.';
      time=p.Leveranstid;
      if(p.Vetefralla && Number(p.Vetefralla)!==0) return 'Vetefralla ingår inte längre i sortimentet. Ta bort den gamla påsen och välj dina sorter igen.';
      if(sorts.some(s=>!/^\d+$/.test(String(p[s]??0))) || sorts.reduce((n,s)=>n+Number(p[s]||0),0)!==size) return 'Antalet valda frallor stämmer inte med påsens storlek. Välj påsen igen.';
      total+=size*line.quantity;
    }
    if(total>20) return 'För fler än 20 frallor: mejla breadtogo.uf@gmail.com så hjälper vi dig med en specialbeställning.';
    return '';
  }
  function message(button, text) {
    let notice = button.parentElement.querySelector('[data-btg-cart-error]');
    if(!notice) {notice=document.createElement('p'); notice.dataset.btgCartError=''; notice.setAttribute('role','alert'); notice.style.cssText='font-size:14px;line-height:1.5;color:#713a25;padding:12px;background:#f5eee3;border-radius:6px';button.before(notice);}
    notice.textContent=text;
  }
  let busy=false;
  async function checkout(button) {
    if(busy)return; busy=true;
    message(button,'Kontrollerar din leverans…');
    try {
      const response=await fetch((window.Shopify?.routes?.root||'/')+'cart.js',{credentials:'same-origin',cache:'no-store'});
      if(!response.ok)throw Error('CART_UNAVAILABLE');
      const error=check(await response.json());
      if(error)message(button,error);
      else window.location.assign((window.Shopify?.routes?.root||'/')+'checkout');
    } catch {message(button,'Varukorgen kunde inte kontrolleras. Försök igen om en stund.');}
    finally {busy=false;}
  }
  document.addEventListener('click',e=>{
    const button=e.target.closest('button[name="checkout"],input[name="checkout"],a[href="/checkout"]');
    if(!button)return; e.preventDefault();e.stopImmediatePropagation();checkout(button);
  },true);
  document.addEventListener('submit',e=>{
    if(e.submitter?.name!=='checkout')return;
    e.preventDefault();e.stopImmediatePropagation();checkout(e.submitter);
  },true);
})();
